import { Title, Center } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { RoutePath, useNavigateToRoute } from 'utils/location';
import { PatientStatus } from 'utils/models';
import { CenteredLoading } from 'components/CenteredLoading';
import { useTotalActivePatients } from 'hooks/api/useUser';
import { InfoCard } from '../InfoCard/InfoCard';

export const WidgetTotalActivePatients = () => {
  const { t } = useTranslation();
  const { data: totalActivePatients, isLoading } = useTotalActivePatients();
  const navigateToRoute = useNavigateToRoute();

  return (
    <InfoCard
      title={t('dashboard_total_active_patients')}
      tooltip={t('dashboard_total_active_patients_tooltip')}
      onClick={() => navigateToRoute(RoutePath.Patients, { status: PatientStatus.Active })}
      testId={'card-total-active-patients'}
    >
      <Center my={'xl'}>
        {
          <Title data-testid={'title-total-active-patients'}>
            {isLoading ? <CenteredLoading /> : totalActivePatients}
          </Title>
        }
      </Center>
    </InfoCard>
  );
};
